export default __webpack_public_path__ + "56b80fc45d38b5ce4017a0605578d160.svg";